import { init } from 'init';

const isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(
    navigator.userAgent
);

if (!isBot) {
    try {
        init();
    } catch (e) {
        throw Error('Favs-agent: Can´t init');
    }
} else {
    console.warn('Favs-agent: Detected bot, skipping init');
}
